import { render, staticRenderFns } from "./tablefield.vue?vue&type=template&id=2a80b418&scoped=true&"
import script from "./tablefield.vue?vue&type=script&lang=js&"
export * from "./tablefield.vue?vue&type=script&lang=js&"
import style0 from "./tablefield.vue?vue&type=style&index=0&id=2a80b418&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a80b418",
  null
  
)

export default component.exports